import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGitlabIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.667 7.91544L19.6389 7.84084L16.9168 0.465194C16.8614 0.320635 16.7633 0.198005 16.6366 0.114899C16.5099 0.0332054 16.362 -0.00614104 16.2131 0.00217258C16.0641 0.0104862 15.9211 0.0660595 15.8035 0.161389C15.6873 0.259455 15.6029 0.392339 15.5619 0.541956L13.7239 6.3802H6.28122L4.4432 0.541956C4.40334 0.391524 4.3188 0.257974 4.2016 0.160308C4.08401 0.0649781 3.94107 0.00940482 3.79209 0.0010912C3.64311 -0.00722243 3.49526 0.032124 3.3685 0.113818C3.24211 0.197259 3.14413 0.319782 3.08838 0.464112L0.361019 7.83652L0.333944 7.91112C-0.0579224 8.97412 -0.106292 10.1406 0.196128 11.2346C0.498548 12.3286 1.13536 13.2909 2.01055 13.9764L2.01993 13.984L2.04492 14.0024L6.19167 17.2264L8.24317 18.8384L9.49282 19.8179C9.63899 19.9331 9.81748 19.9955 10.001 19.9955C10.1845 19.9955 10.363 19.9331 10.5092 19.8179L11.7588 18.8384L13.8104 17.2264L17.9821 13.9829L17.9925 13.9742C18.8657 13.2886 19.5011 12.3273 19.803 11.2348C20.105 10.1422 20.0573 8.97743 19.667 7.91544Z",
			fill: "#E24329"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6671 7.91554L19.6389 7.84094C18.3125 8.1236 17.0626 8.7069 15.9785 9.54917L10 14.2425C12.0359 15.8415 13.8083 17.2308 13.8083 17.2308L17.98 13.9873L17.9905 13.9787C18.8649 13.2931 19.5013 12.3312 19.8036 11.2377C20.106 10.1442 20.0581 8.97831 19.6671 7.91554Z",
			fill: "#FC6D26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.19165 17.2309L8.24316 18.8429L9.4928 19.8224C9.63898 19.9376 9.81746 20 10.001 20C10.1845 20 10.363 19.9376 10.5092 19.8224L11.7588 18.8429L13.8103 17.2309C13.8103 17.2309 12.0358 15.8373 9.99995 14.2426C7.96407 15.8373 6.19165 17.2309 6.19165 17.2309Z",
			fill: "#FCA326"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.0204 9.54922C2.93716 8.70522 1.68752 8.1204 0.36102 7.83667L0.333944 7.91127C-0.0579224 8.97427 -0.106292 10.1407 0.196128 11.2348C0.498548 12.3288 1.13536 13.2911 2.01055 13.9766L2.01993 13.9841L2.04492 14.0025L6.19167 17.2265C6.19167 17.2265 7.962 15.8372 9.99997 14.2382L4.0204 9.54922Z",
			fill: "#FC6D26"
		})
	]
});
export default SvgGitlabIcon;
